import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { assignKennels, saveArea, saveStaff, reloadFacilities } from '../../actions/facilities/facilities.actions'
import { getVisitsByFacilityId } from '../../actions/visits/visits.actions'
import { PlayAreaDialog, StaffDialog } from '../../components/Dialogs'
import KennelBlockDialogNew from '../../components/Dialogs/KennelBlockDialogNew'
import { PlaygroupsTable } from '../../components/Tables/PlaygroupsTable'
import { STATUS_ID } from '../../utils'
import Loading from '../common/Loading'
import LoadingOverlay from '../../components/Misc/LoadingOverlay'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px'
	}
}))

const Playgroups = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const facility = useSelector((state) => state.specific.facilities.selected)
	const loading = useSelector((state) => state.specific.facilities.loading)
	const staff = useSelector((state) => state.specific.facilities.staff)
	const visits = useSelector((state) => state.specific.visits.visits)
	const pets = useSelector((state) => state.specific.visits.pets)
	const [selectedPlaygroup, selectPlaygroup] = useState(null)
	const [date, setDate] = useState(moment().format('YYYY-MM-DD'))
	const [kbShown, setKbShown] = useState(false)
	const [dialog, setDialog] = useState(false)
	const [openMenus, setOpenMenus] = useState([])

	const [playAreaShown, setPlayShown] = useState(null)

	const changeDate = (type) => {
		if (type === 'add') {
			setDate(moment(date).add(1, 'd').format('YYYY-MM-DD'))
		} else if (type === 'subtract') {
			setDate(moment(date).subtract(1, 'd').format('YYYY-MM-DD'))
		}
	}

	useEffect(() => {
		if (facility) {
			dispatch(getVisitsByFacilityId(facility, date))
		}
	}, [date, facility])

	const setIsShown = (shown, group) => {
		setDialog(shown)
		selectPlaygroup(group)
	}

	useEffect(() => {
		dispatch(reloadFacilities(false))
	}, [])

	const getUnassigned = () => {
		let pet_ids = []
		visits.forEach((v, i) => {
			if (
				v.pet_status &&
				v.status &&
				![STATUS_ID.Cancelled, STATUS_ID['No Show']].includes(v.status.id) &&
				v.type !== 'grooming'
			) {
				v.pet_status.forEach((stat, i) => {
					if (!stat.playgroup) pet_ids.push(stat.pet_id)
				})
			}
		})
		const unPets = pet_ids
			.map((id) => {
				return pets.find((p) => p._id === id)
			})
			.filter(Boolean)

		// console.info({ visits, unPets })

		return unPets.length
	}

	const isDaytimeVisit = (vis) => {
		if (vis.type === 'daycare') {
			return vis?.dates?.includes(date)
		} else if (vis?.type === 'boarding') {
			const dateIndex = vis?.dates && vis?.dates.findIndex((d) => d === date)
			if (dateIndex === 0) {
				return !!vis?.first_day_daycare
			} else if (dateIndex === vis?.dates.length - 1) {
				return !!vis?.last_day_daycare
			} else {
				return true
			}
		}
		return true
	}

	const getDayTimePets = () => {
		let daytime = visits.filter(
			(v) => [2, 3, 4, 5].includes(v?.status?.id) && v.type !== 'grooming' && !!isDaytimeVisit(v)
		)

		return daytime.reduce((acc, visit) => acc + visit.pets.length, 0)
	}

	const getNeedGroupPets = () => {
		const dayTimePets = getDayTimePets()
		// for Skiptown South End
		let lowEnd = 0
		let highEnd = 0
		// if (facility._id === '5ed169c1e06b770017a4504f') {
		lowEnd = Math.ceil(dayTimePets / 10)
		highEnd = lowEnd + 1
		// }

		return [lowEnd, highEnd]
	}

	const setMenus = (id) => {
		if (openMenus.includes(id)) {
			setOpenMenus(openMenus.filter((i) => i !== id))
		} else {
			setOpenMenus([...openMenus, id])
		}
	}

	return (
		<div className={classes.root}>
			{facility && visits ? (
				<div className={classes.visitsTableContainer}>
					{loading && <LoadingOverlay />}
					<PlaygroupsTable
						loading={loading}
						unassigned_pets={getUnassigned()}
						daytime_pets={getDayTimePets()}
						need_group_pets={getNeedGroupPets()}
						facility={facility}
						areas={facility.areas}
						pets={pets}
						date={date}
						visits={visits.filter(
							(v) =>
								v.status &&
								![STATUS_ID.Cancelled, STATUS_ID['No Show']].includes(v.status.id) &&
								v.type !== 'grooming'
						)}
						changeDate={changeDate}
						setDate={setDate}
						playgroup_types={facility.playgroup_types || []}
						playgroups={(facility.playgroups || []).filter((p) => p.status && p.status !== 'disabled')} // active or overflow
						kennel_blocks={facility.kennel_blocks || []}
						kennels={facility.kennels || []}
						setDialogShown={(val, group) => {
							selectPlaygroup(group)
							setKbShown(val)
						}}
						setIsShown={(val, group) => setIsShown(val, group)}
						setPlayShown={(val, group) => {
							selectPlaygroup(group)
							setPlayShown(val)
						}}
						staff={[]}
						openMenus={openMenus}
						openMenu={setMenus}
						setGroup={(group_id) => dispatch({ type: 'SET_GROUP', payload: group_id })}
					/>
					<StaffDialog
						isShown={dialog}
						setIsShown={setIsShown}
						staff={staff}
						group={selectedPlaygroup}
						facility={facility}
						setStaff={(arr, time, group) => {
							dispatch({
								type: 'SET_STAFF',
								payload: { time, staff: arr, playgroup_id: group._id }
							})
							selectPlaygroup({
								...group,
								staff: {
									...group.staff,
									[time]: arr
								}
							})
						}}
						saveStaff={(obj) => {
							dispatch(saveStaff(selectedPlaygroup._id, obj))
							setIsShown(false)
						}}
					/>
					<KennelBlockDialogNew
						isShown={kbShown}
						setIsShown={setKbShown}
						staff={staff}
						facility={facility}
						multiple
						playgroup={selectedPlaygroup}
						assignKennels={(kens) => {
							dispatch(assignKennels(facility._id, selectedPlaygroup._id, kens))
							setKbShown(false)
						}}
					/>
					<PlayAreaDialog
						isShown={playAreaShown}
						setIsShown={setPlayShown}
						staff={staff}
						facility={facility}
						selectedPlaygroup={selectedPlaygroup}
						saveArea={(group, area) => {
							dispatch(saveArea(facility._id, group, area))
						}}
					/>
				</div>
			) : (
				<Loading />
			)}
		</div>
	)
}

export default Playgroups
